export default {
  common: {
    save: "சேமி",
    cancel: "ரத்து செய்",
    back: "பின்",
    submit: "சமர்ப்பி",
    loading: "ஏற்றுகிறது…",
    yes: "ஆம்",
    no: "இல்லை",
    confirm: "உறுதிப்படுத்து",
    close: "மூடு",
    search: "தேடு",
    all: "அனைத்தும்",
    done: "முடிந்தது",
    logout: "வெளியேறு",
    language: "மொழி",
    selectLanguage: "உங்கள் மொழியைத் தேர்ந்தெடுக்கவும்",
    saving: "சேமிக்கிறது…",
    saved: "சேமிக்கப்பட்டது",
    viewAll: "அனைத்தையும் காண்க",
    filters: "வடிகட்டிகள்",
  },
  nav: {
    home: "முகப்பு",
    installs: "நிறுவல்கள்",
    requests: "கோரிக்கைகள்",
    orders: "ஆர்டர்கள்",
    profile: "சுயவிவரம்",
    leads: "லீட்ஸ்",
    service: "சேவை",
    payouts: "பணம் செலுத்துதல்",
    toolkit: "கருவித்தொகுப்பு",
  },
  profile: {
    yourAccount: "உங்கள் கணக்கு",
    title: "சுயவிவரம்.",
    city: "நகரம்",
    state: "மாநிலம்",
    pinCode: "பின் கோடு",
    pinCodeHelp: "இந்த பின் கோடு சேரும் அனுமதிக்கப்பட்ட பகுதியே உங்கள் பிராந்தியம்.",
    upiId: "UPI ஐடி (பணம் பெற)",
    saveProfile: "சுயவிவரத்தை சேமி",
    preferredLanguage: "விருப்ப மொழி",
    logoutConfirm: "நீங்கள் நிச்சயமாக வெளியேற விரும்புகிறீர்களா?",
    linkedAddresses: "இணைக்கப்பட்ட முகவரிகள்",
    noAddresses: "இதுவரை முகவரி எதுவும் சேமிக்கப்படவில்லை.",
    referFriend: "நண்பரை பரிந்துரை செய்",
    referFriendSub: "உங்கள் கோடை பகிரவும் — அவர்கள் சோலார் பொருத்தினால் உங்களுக்கு வெகுமதி கிடைக்கும்.",
    myReferrals: "எனது பரிந்துரைகள்",
    shareFriend: "நண்பருடன் பகிரவும்",
    secureNote: "உங்கள் தரவு பாதுகாப்பான போன் OTP மூலம் சரிபார்க்கப்பட்டது — கடவுச்சொல் நினைவில் வைக்கவோ இழக்கவோ தேவையில்லை.",
    toolkit: "கருவித்தொகுப்பு",
    incentiveSchemes: "ஊக்கத்தொகை திட்டங்கள்",
  },
  tickets: {
    myRequests: "எனது கோரிக்கைகள்",
    raiseComplaint: "புகார் அளிக்கவும்",
    cancelRequest: "கோரிக்கையை ரத்து செய்",
    cancelConfirmTitle: "இந்த கோரிக்கையை ரத்து செய்யவா?",
    cancelConfirmBody: "இந்த சேவைக் கோரிக்கையில் வேலையை நிறுத்துவோம். பிறகு மீண்டும் புதிய கோரிக்கை செய்யலாம்.",
    cancelledToast: "கோரிக்கை ரத்து செய்யப்பட்டது",
    keepRequest: "இல்லை, வைத்திரு",
    noRequests: "இதுவரை சேவைக் கோரிக்கைகள் இல்லை.",
    statusOpen: "திறந்துள்ளது",
    statusInProgress: "நடைபெறுகிறது",
    statusOnHold: "நிறுத்தி வைக்கப்பட்டது",
    statusActionNeeded: "நடவடிக்கை தேவை",
    statusCompleted: "முடிந்தது",
    statusClosed: "மூடப்பட்டது",
    statusCancelled: "ரத்து செய்யப்பட்டது",
    statusDropped: "கைவிடப்பட்டது",
    filterAll: "அனைத்தும்",
    filterActive: "செயலில்",
    filterResolved: "தீர்க்கப்பட்டது",
    nonServiceable: "சேவை கிடைக்காத பகுதி",
    raisedOn: "அளிக்கப்பட்ட தேதி",
    ticketNumber: "டிக்கெட்",
    wipInstall: "நிறுவல் நடைபெறுகிறது",
    raisedByYou: "நீங்கள் அளித்தது",
    raisedByTeam: "எங்கள் குழு அளித்தது",
    timeline: "காலவரிசை",
    pending: "நிலுவையில்",
    resolutionSummary: "தீர்வு சுருக்கம்",
    youRatedPrefix: "நீங்கள் இதை மதிப்பிட்டீர்கள்",
    howWasResolution: "தீர்வு எப்படி இருந்தது?",
    submitFeedback: "கருத்தை சமர்ப்பிக்கவும்",
  },
  home: {
    greeting: "வணக்கம்",
    newInstallation: "புதிய நிறுவல்",
    raiseComplaint: "புகார் அளிக்கவும்",
    welcomeBack: "மீண்டும் வரவேற்கிறோம்",
    customerSubtitle: "பூர்வோதயத்துடன் உங்கள் சோலார் பயணம், அனைத்தும் ஒரே இடத்தில்.",
  },
  sc: {
    requestsTitle: "சேவை கோரிக்கைகள்",
    requestsForCustomers: "உங்கள் வாடிக்கையாளர்களுக்காக",
    kpiOpen: "திறந்தவை",
    kpiResolved: "தீர்க்கப்பட்டது",
    kpiInProblem: "சிக்கலில்",
    raiseRequest: "சேவை கோரிக்கையை அளிக்கவும்",
    slaBreached: "SLA மீறல்",
    viewPhotos: "புகைப்படங்களைக் காண்க",
    hidePhotos: "புகைப்படங்களை மறை",
    noRequestsWindow: "இந்த காலகட்டத்தில் சேவை கோரிக்கைகள் இல்லை.",
  },
};
